'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalPjeOfficeSignHashRequest(origin, algo, hashes) {
  this.C3 = null;
  this.J4 = null;
  this.J5 = null;
  this.C3 = origin;
  this.J4 = algo;
  this.J5 = hashes;
}
export { $c_Lpresto_AgentView$LocalPjeOfficeSignHashRequest as $c_Lpresto_AgentView$LocalPjeOfficeSignHashRequest };
$p = $c_Lpresto_AgentView$LocalPjeOfficeSignHashRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalPjeOfficeSignHashRequest;
/** @constructor */
function $h_Lpresto_AgentView$LocalPjeOfficeSignHashRequest() {
}
export { $h_Lpresto_AgentView$LocalPjeOfficeSignHashRequest as $h_Lpresto_AgentView$LocalPjeOfficeSignHashRequest };
$h_Lpresto_AgentView$LocalPjeOfficeSignHashRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_AgentView$LocalPjeOfficeSignHashRequest)) {
    if (((this.C3 === x$0.C3) && (this.J4 === x$0.J4))) {
      var x = this.J5;
      var x$2 = x$0.J5;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "LocalPjeOfficeSignHashRequest";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.C3;
      break;
    }
    case 1: {
      return this.J4;
      break;
    }
    case 2: {
      return this.J5;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.pn = (function() {
  return this.C3;
});
function $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignHashRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hG)));
}
export { $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignHashRequest as $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignHashRequest };
var $d_Lpresto_AgentView$LocalPjeOfficeSignHashRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalPjeOfficeSignHashRequest, "presto.AgentView$LocalPjeOfficeSignHashRequest", ({
  hG: 1,
  b5: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AgentView$LocalPjeOfficeSignHashRequest as $d_Lpresto_AgentView$LocalPjeOfficeSignHashRequest };
//# sourceMappingURL=presto.-Agent-View$-Local-Pje-Office-Sign-Hash-Request.js.map
